module.exports = "pegasus/assets/blocks/column-6-theme3.png";